'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../../../../..');

var _2 = _interopRequireDefault(_);

var _ListView = require('../../ListView');

var _ShortText = require('material-ui-icons/ShortText');

var _ShortText2 = _interopRequireDefault(_ShortText);

var _3 = require('../..');

var _reactNumberFormat = require('react-number-format');

var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _DefaultValue = require('./DefaultValue');

var _DefaultValue2 = _interopRequireDefault(_DefaultValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var NamedField = (_temp = _class = function (_EditorComponent) {
  _inherits(NamedField, _EditorComponent);

  function NamedField() {
    _classCallCheck(this, NamedField);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  NamedField.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_ShortText2.default, null), ' Object field'));
  };

  NamedField.prototype.getRootElement = function getRootElement() {
    var _getComponentProps = this.getComponentProps(this),
        tag = _getComponentProps.tag;

    return tag || "span";
  };

  NamedField.prototype.renderBadgeTitle = function renderBadgeTitle(title) {
    var Grid = this.context.Grid;

    var _getComponentProps2 = this.getComponentProps(this),
        name = _getComponentProps2.name;

    return _react2.default.createElement(Grid, {
      container: true,
      spacing: 8,
      alignItems: 'center',
      style: {
        flexWrap: "nowrap"
      }
    }, _react2.default.createElement(Grid, {
      item: true
    }, _EditorComponent.prototype.renderBadgeTitle.call(this, title)), name ? _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement('b', null, name)) : null);
  };

  NamedField.prototype.getComponentProps = function getComponentProps(component) {
    var _EditorComponent$prot = _EditorComponent.prototype.getComponentProps.call(this, component),
        type = _EditorComponent$prot.type,
        props = _objectWithoutProperties(_EditorComponent$prot, ['type']);

    var otherProps = {};

    switch (type) {
      case "number":
        var _props$thousandSepara = props.thousandSeparator,
            thousandSeparator = _props$thousandSepara === undefined ? " " : _props$thousandSepara,
            _props$decimalSeparat = props.decimalSeparator,
            decimalSeparator = _props$decimalSeparat === undefined ? "." : _props$decimalSeparat,
            decimalScale = props.decimalScale,
            prefix = props.prefix,
            suffix = props.suffix,
            defaultValue = props.defaultValue,
            _props$isNumericStrin = props.isNumericString,
            isNumericString = _props$isNumericStrin === undefined ? false : _props$isNumericStrin,
            _props$displayType = props.displayType,
            displayType = _props$displayType === undefined ? "text" : _props$displayType,
            mask = props.mask;
        otherProps = {
          thousandSeparator: thousandSeparator,
          decimalSeparator: decimalSeparator,
          decimalScale: decimalScale ? parseInt(decimalScale) : undefined,
          prefix: prefix,
          suffix: suffix,
          defaultValue: defaultValue ? parseFloat(defaultValue) : undefined,
          isNumericString: isNumericString,
          displayType: displayType,
          mask: mask
        };
        break;
    }

    return _extends({
      type: type
    }, props, otherProps);
  };

  NamedField.prototype.renderChildren = function renderChildren() {
    var _this2 = this; // const {
    //   UserLink,
    // } = this.context;


    var _getComponentProps3 = this.getComponentProps(this),
        name = _getComponentProps3.name,
        type = _getComponentProps3.type,
        override_context = _getComponentProps3.override_context,
        other = _objectWithoutProperties(_getComponentProps3, ['name', 'type', 'override_context']);

    if (!name) {
      return null;
    }

    var _getEditorContext2 = this.getEditorContext(),
        inEditMode = _getEditorContext2.inEditMode;
    /**
     * Дочерние элементы выводим только в том случае, если значение массив или объект,
     * иначе есть вероятность, что на нижних уровнях компоненты попадут в контект не того объекта
     */


    return _react2.default.createElement(_ListView.ObjectContext.Consumer, null, function (context) {
      var object = context.object,
          otherContext = _objectWithoutProperties(context, ['object']);

      if (!object) {
        return null;
      }

      var output = null;

      if (name) {
        var value = object[name];
        var children = _EditorComponent.prototype.renderChildren.call(_this2) || [];
        var childrenWithoutDefaultValue = children.filter(function (n) {
          return n && n.type !== _DefaultValue2.default;
        });
        /**
        Так как без опеределения типа данных мы можем уйти не в тот контекст, возвращаем ничего,
        если значение отсутствует или null
         */

        if (value !== undefined || true) {
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === "object" && value !== null) {
            if (Array.isArray(value)) {
              /**
              Если это массив, то передаем как массив объектов.
              Если объект, то передаем как объект
               */
              output = value.length ? children.filter(function (n) {
                return n && n.type !== _DefaultValue2.default;
              }) : children.filter(function (n) {
                return n && n.type === _DefaultValue2.default;
              });

              if (override_context) {
                output = _react2.default.createElement(_3.ConnectorContext.Provider, {
                  value: {
                    data: {
                      objects: value
                    }
                  }
                }, output);
              }
            } else {
              // children = children.filter(n => n && n.type !== DefaultValue);
              // output = value ? children.filter(n => n && n.type !== DefaultValue) : children.filter(n => n && n.type === DefaultValue);
              output = value ? childrenWithoutDefaultValue : children.filter(function (n) {
                return n && n.type === _DefaultValue2.default;
              });

              if (override_context) {
                output = _react2.default.createElement(_ListView.ObjectContext.Provider, {
                  value: {
                    object: value
                  }
                }, output);
              }
            }
          } else if (!value) {
            /**
            Есть предположение, что надо перетирать контекст, даже если нет объекта.
            Но это сейчас больше неудобств добавить.
            Вероятнее всего надо добавлять сущность новую Child для предполагаемого дочернего объекта 
            и Children для предполагаемого массива дочерних объектов
             */
            children = children.filter(function (n) {
              return n && n.type === _DefaultValue2.default;
            });
            output = children;
          }
          /**
          Если есть скалярное значение
           */
          else {
              /**
              Если есть дочерние элементы, то выводим их.
               */
              if (childrenWithoutDefaultValue.length) {
                /**
                Даже если за вычетом дефолтных элементов не останется дочерних элементов,
                все равно выводим остаточный пустой массив, а не само значение,
                так как логика может быть заложена именно на проверку значения,
                чтобы ничего не выводить, если значение есть.
                 */
                // children = children.filter(n => n && n.type !== DefaultValue);
                output = childrenWithoutDefaultValue;
              }
              /**
              Иначе выводим просто скалярное значение
               */
              else {
                  value = _this2.prepareScalarValue(value, context);

                  switch (type) {
                    case "number":
                      {
                        var defaultValue = other.defaultValue;
                        output = _react2.default.createElement(_reactNumberFormat2.default, _extends({
                          value: value || defaultValue || ""
                        }, other));
                      }
                      break;

                    case "date":
                      if (value) {
                        var format = other.format;
                        var date = (0, _moment2.default)(value);

                        if (date.isValid()) {
                          if (format) {
                            date = date.format(format);
                          }

                          output = date.toString();
                        } else {
                          output = _react2.default.createElement(_Typography2.default, {
                            color: 'error'
                          }, 'Invalid date');
                        }
                      }

                      break;

                    default:
                      output = value;
                  }
                }
            }
        }
      }

      {
        /* 
         } */
      }
      return output; // return value && (typeof value !== "object") ? value : null;
    });
  };

  NamedField.prototype.prepareScalarValue = function prepareScalarValue(value, context) {
    return value;
  };

  return NamedField;
}(_2.default), _class.Name = "NamedField", _class.propTypes = _extends({}, _2.default.propTypes, {
  /**
   * Если нет, то контекст родителя не будет перетерт.
   * Это удобно для того, чтобы просто проверять на наличие значения.
   */
  override_context: _propTypes2.default.bool.isRequired
}), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  name: "",
  tag: "span",
  type: undefined,
  format: undefined,
  override_context: true,
  hide_wrapper_in_default_mode: true
}), _temp);
exports.default = NamedField;
module.exports = exports['default'];